import React from 'react';
import { AppStoreIcon, PlayMarketIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

const AppDownSection = () => {
  const t = useTranslations();

  return (
    <div className="my-28 rounded-2xl bg-white shadow-sm">
      <div className="flex flex-col-reverse items-center gap-10 sm:grid sm:grid-cols-2">
        <div className="ml-7">
          <p className="mb-3 font-medium text-green-500">Akam Mobile</p>
          <h2 className="mb-6 text-2xl font-semibold lg:text-3xl lg:leading-[2rem]">{t('home.app_down.main_title')}</h2>
          <p className="text-sm md:text-base lg:font-medium">{t('home.app_down.desc')}</p>
          <div className="my-8 flex gap-0 md:justify-normal md:gap-1">
            <Link
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.test.aim.uz"
              className="w-35 block"
              aria-label="Google Play orqali yuklab olish"
            >
              <PlayMarketIcon />
            </Link>
            <Link
              target="_blank"
              href="https://apps.apple.com/uz/app/akam-onlayn-testlar/id1619248324"
              className="w-35 block"
              aria-label="App Store orqali yuklab olish"
            >
              <AppStoreIcon />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 p-3 md:p-0">
          <Image
            src="/images/app-design.webp"
            alt="Download on the App Store"
            width={630}
            height={300}
            title="App Store orqali yuklab oling"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default AppDownSection;
